import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const metaRowClass = flex({
	alignItems: "center",
	justifyContent: "space-between",
	gap: "8",
});

export const whenClass = css({
	fontSize: "12",
	color: "shade.40",
});

export const adminEmailActionClass = css({
	borderColor: "warning.100 !important",
	"& .p-fieldset-legend": {
		color: "warning.100 !important",
		borderColor: "warning.100 !important",
	},
});

export const adminCloseOrderClass = css({
	borderColor: "error.100 !important",
	"& .p-fieldset-legend": {
		color: "error.100 !important",
		borderColor: "error.100 !important",
	},
});
